import React from 'react';
import { trackCommentary } from '../../../../commentary/commentary.api';
import { Hyperlink } from '../../../../components/Hyperlink';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { withUser } from '../../../../user/UserContext';
import { sendResultClickedEvent } from '../../../search-utils';
import { getCommentUrl } from './searchCommentUtils';
import { SearchComment } from './searchResultComment.types';
import { UserContextType } from '../../../../user/user.types';

type Props = {
  comment: SearchComment;
  index: number;
  originalQueryKey: string;
} & UserContextType &
  WithRestrictedModalProps;

export class RawSearchResultCommentTitle extends React.Component<Props> {
  onTitleClick = () => {
    const {
      comment,
      accessPremium,
      openRestrictedModal,
      index,
      originalQueryKey,
    } = this.props;
    if (accessPremium) {
      sendResultClickedEvent(comment, originalQueryKey);
      trackCommentary(comment.url, 'excerpt_results_comment', {
        position: index,
      });
    } else {
      openRestrictedModal('excerpt_results_comment');
    }
  };

  render() {
    const { comment, accessPremium } = this.props;
    const commentUrl = getCommentUrl(comment.url, accessPremium);
    return (
      <Hyperlink
        className="excerpt_comment__comment__title"
        {...(accessPremium ? { href: commentUrl, target: '_blank' } : {})}
        onClick={this.onTitleClick}
        dangerouslySetInnerHTML={{ __html: comment.title }}
        data-test-id="search-comment-title-link"
      />
    );
  }
}

export const SearchResultCommentTitle = withUser(
  withRestrictedModal(RawSearchResultCommentTitle),
);
